<template>
    <div class="ma-2 pa-2">
        <v-row dense>
            <v-col cols="12" :class=cbsa[0] v-bind:style="sbsa[0]">
                화재알리미 개인정보처리방침
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                1. 개인정보처리 방침 정의
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                ㈜파이어룩스 (이하"회사")는 이용자의 ‘동의를 기반으로 개인정보를 수집·이용 및 제공’하고 있으며, '이용자의 권리 (개인정보 자기결정권)를 적극적으로 보장'합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                회사는 정보통신서비스제공자가 준수하여야 하는 대한민국의 관계 법령 및 개인정보보호 규정, 가이드라인을 준수하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                "개인정보처리방침"이란 이용자의 소중한 개인정보를 보호함으로써 이용자가 안심하고 서비스를 이용할 수 있도록 회사가 준수해야 할 지침을 의미합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                본 개인정보처리방침은 회사가 제공하는 화재장비제어 서비스(이하 '서비스'라 함)에 적용됩니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                2. 개인정보의 수집 항목 및 이용 목적
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별 어플리케이션이나 프로그램 등을 통해 아래와 같은 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 회사는 다음과 같이 개인정보를 수집, 이용합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 수집정보
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 단말기정보(OS, 디바이스 아이디, 폰기종, 단말기 모델명)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 이름, 주소, 전화번호
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                나. 이용목적
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 고객의 스마트폰에 설치되어 있는 App, 신상 정보 및 거주 주소 확인을 통한 서비스 제공
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                3) 서비스에서는 법령에 따라 동의없이 수집할 수 있는 자동생성 정보(로그기록 등 서비스 계약 이행과정에서 자동적으로 생성되는 정보),
                요금정산에 필요한 정보 등을 필수동의 사항에 기재된 목적범위 내에서 수집하여 이용할 수 있습니다.
                또한, 서비스에서는 수집한 개인정보를 개인을 알아볼 수 없는 통계자료 등으로 가공하여 이용 또는 제공할 수 있습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                3. 개인정보 수집에 대한 동의
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                회사는 고객님께서 개인정보의 수집, 이용에 관한 내용에 대해 「동의한다」 또는 「동의하지 않는다」
                버튼을 클릭할 수 있는 절차를 마련하고 있으며, 고객님께서 「동의한다」 버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                4. 개인정보의 수집 방법
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                • 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                • 제휴 서비스 또는 단체 등으로부터 개인정보를 제공받은 경우 (회원가입 포함)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                • 고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                • 온·오프라인에서 진행되는 이벤트/행사 등 참여
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                5. 수집한 개인정보의 이용 및 제3자 제공
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회사는 고객님의 개인정보를 개인정보취급방침의 「개인정보의 수집 및 이용목적」에서 고지한 범위 내에서 사용하며,
                동 범위를 초과하여 이용하거나 타인 또는 타기업, 기관에 제공하지 않습니다.
                단, 다음의 경우에는 주의를 기울여 개인정보를 이용 및 제공할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 제휴관계
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                보다 나은 서비스 제공을 위하여 고객님의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다.
                개인정보를 제공하거나 공유할 경우에는 사전에 고객님께 제휴사가 누구인지,
                제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지,
                그리고 언제까지 어떻게 보호, 관리되는지에 대해 개별적으로 서면 또는 E-mail 등을 통해 고지하여 동의를 구하는 절차를 거치게 되며,
                고객님께서 동의하지 않는 경우에는 제휴사에게 제공하거나 제휴사와 공유하지 않습니다.
                제휴관계에 변화가 있거나 제휴관계가 종결될 때도 같은 절차에 의하여 고지하거나 동의를 구합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                나. 매각, 인수합병 등
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                영업의 전부 또는 일부를 양도하거나, 합병, 상속 등으로 서비스제공자의 권리, 의무를 이전 승계하는 경우
                개인정보보호 관련 고객님의 권리를 보장하기 위하여 반드시 그 사실을 고객님께 통지합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 회사는 본 서비스의 개인정보를 개인정보 수집 시 고객님께 고지하고 동의를 얻은 범위를 넘어 이용하거나 제3자에게 제공하지 않습니다.
                다만, 고객님의 동의가 있거나 다음에 해당하는 경우에는 예외로 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 서비스의 제공에 관한 계약의 이행을 위하여 필요한 개인정보로서 경제적, 기술적인 사유로 통상의 동의를 받는 것이 현저히 곤란한 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                나. 서비스 제공에 따른 요금정산을 위하여 필요한 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                다. 통신비밀보호법, 국세기본법, 정보통신망법, 개인정보보호법, 금융실명거래 및 비밀보장에 관한 법률,
                신용정보의 이용 및 보호에 관한 법률, 전기통신기본법, 전기통신사업법, 지방세법, 소비자기본법, 한국은행법,
                형사소송법 등 다른 법률에 특별한 규정이 있는 경우.
                단, '법률에 특별한 규정이 있는 경우'로 행정목적이나 수사목적으로 행정관청 또는 수사기관이 요구해 온 경우라도
                무조건 고객님의 개인정보를 제공하지 않으며, 법률에 규정된 바에 따라 영장 또는 기관장의 직인이 날인된
                서면에 의한 경우 등 적법한 절차에 따라 제공합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                라. 통계작성/학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                6. 개인정보의 열람 및 정정
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 고객님은 언제든지 등록되어 있는 고객님의 개인정보를 열람하거나 정정하실 수 있습니다.
                개인정보 열람 및 정정을 하고자 할 경우에는 애플리케이션 내의 1:1 문의,
                개인정보관리책임자 및 담당자에게 서면, 전화 또는 E-mail로 연락하시면 지체 없이 조치하겠습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 고객님께서 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 당해 개인 정보를 이용 또는 제공하지 않습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                3) 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정하도록 조치하겠습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                7. 개인정보의 수집, 이용, 제공에 대한 동의 철회
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회원가입 등을 통해 개인정보의 수집, 이용, 제공에 대해 고객님께서 동의하신 내용을 고객님께서는 언제든지 철회하실 수 있습니다.
                동의 철회는 애플리케이션 내의 1:1 문의 혹은 개인정보관리책임자에게 서면, 전화, E-mail등으로 연락하시면 지체없이 회원탈퇴를 위해 필요한 조치를 취합니다.
                동의 철회를 하고 개인정보를 파기하는 등의 조치를 취한 경우에는 그 사실을 고객님께 지체 없이 통지하도록 하겠습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 회사는 개인정보의 수집에 대한 동의철회를 개인정보를 수집하는 방법보다 쉽게 할 수 있도록 필요한 조치를 취합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                8. 개인정보의 보유 및 이용기간
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회사는 고객님의 서비스 가입일로부터 고객님께 서비스를 제공하는 기간 동안에 한하여 고객님의 개인정보를 보유 및 이용하게 됩니다.
                개인정보의 수집 및 이용에 대한 동의를 철회하는 경우, 수집/이용목적을 달성하거나 보유/이용기간이 종료한 경우, 사업폐지 등의 사유발생시 당해 개인정보를 지체 없이 파기합니다.
                단, 이용요금의 정산, 소송이나 분쟁 등 기타 필요한 경우를 대비하여 일정기간 보유하여야 할 필요가 있을 경우 개인정보는 해지 후 6개월 간 보유합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 상법 및 전자상거래 등에서의 소비자보호에 관한 법률, 전자금융거래법, 여신전문금융업법 국세기본법, 법인세법, 부가가치세법 등
                관련 법령의 규정에 의하여 다음과 같이 거래 관련 권리 의무 관계의 확인을 위하여 일정기간 보유하여야 할 필요가 있을 경우
                개인정보는 일정기간 보유되며, 이 때 보유되는 개인정보의 열람 및 이용은 해당 사유로 국한되며,
                사전에 보유목적, 기간 및 보유하는 개인정보 항목을 명시하여야 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 개별적으로 고객님의 동의를 받은 경우에는 약속한 보유기간
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                나. 통신사실확인자료 제공 시 필요한 가입자의 전기통신 일시, 전기통신 개시/종료시간, 통신번호 등 상대방의 가입자번호, 통신망에 접속된 정보통신기기의 위치 추적자료 : 12개월 (통신비밀보호법)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                다. 통신사실확인자료 제공 시 필요한 로그기록자료, IP주소 등 : 3개월 (통신비밀보호법)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                라. 표시/광고에 관한 기록 : 6개월 (전자상거래등에서의 소비자보호에 관한 법률)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                마. 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래등에서의 소비자보호에 관한 법률(이하 "전자상거래법"이라 함))
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                바. 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                사. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                아. 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (신용정보의 이용 및 보호에 관한 법률)
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                보다 나은 서비스 제공을 위하여 고객님의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다.
                개인정보를 제공하거나 공유할 경우에는 사전에 고객님께 제휴사가 누구인지,
                제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지,
                그리고 언제까지 어떻게 보호, 관리되는지에 대해 개별적으로 서면 또는 E-mail 등을 통해 고지하여 동의를 구하는 절차를 거치게 되며,
                고객님께서 동의하지 않는 경우에는 제휴사에게 제공하거나 제휴사와 공유하지 않습니다.
                제휴관계에 변화가 있거나 제휴관계가 종결될 때도 같은 절차에 의하여 고지하거나 동의를 구합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                3) 고객님의 동의를 받아 보유하고 있는 거래정보에 대해 고객님께서 열람을 요구하는 경우에는 지체 없이 해당 정보를 열람/ 확인할 수 있도록 조치합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                9. 개인정보 파기 절차 및 방법
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                회사는 수집한 개인정보의 이용목적이 달성된 후에는 보관기간 및 이용기간에 따라 해당 정보를 지체 없이 파기합니다. 파기절차, 방법, 시점은 다음과 같습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 파기절차 및 시점
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                고객님이 서비스 가입 등을 위해 기재한 개인정보는 서비스 해지 등 이용목적이 달성된 후 내부 방침 및
                기타 관련 법령에 의한 정보보호 사유(위 개인정보의 보유 및 이용기간 참조)에 따른 보유기간이 경과한 후에 삭제되거나 파기합니다.
                일반적으로 잔존하는 채권, 채무 관계가 없는 경우 본 서비스 회원가입 시 수집되어 전자적 파일형태로 관리하는 개인정보는 회원 탈퇴 시점에 바로 삭제 됩니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 파기방법
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                종이에 출력된 개인정보는 분쇄기로 분쇄 또는 소각하거나 화학약품 처리를 하여 용해하여 파기하고,
                전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                10. 만 14세 미만 아동의 법정대리인의 권리와 그 행사 방법
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                만 14세 미만 아동은 서비스를 이용할 수 없습니다. 만약 회사가 만 14세 미만의 아동으로부터
                개인정보 수집•이용•제공하는 경우, 관련 법령에 따라 그 법정대리인의 동의를 받습니다.
                이 경우 회사는 그 아동에게 법정대리인의 동의를 받기 위하여 필요한 법정대리인의 성명 등 최소한의 정보를 요구할 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                만 14세 미만 아동의 법정대리인은 아동의 개인정보에 대한 열람, 수정 및 삭제를 요청할 수 있으며, 회사는 이러한 요청에 지체 없이 필요한 조치를 취합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                11. 이용자의 권리와 의무
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회사는 고객님의 의견을 매우 소중하게 생각하며, 고객님은 의문사항으로부터 언제나 성실한 답변을 받을 권리가 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 고객님의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를 예방해 주시기 바랍니다.
                입력한 부정확한 정보로 인해 발생하는 사고의 책임은 고객님께 있으며 타인 정보의 도용 등 허위정보를 입력할 경우 회원자격이 상실될 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                3) 고객님은 개인정보를 보호받을 권리와 함께 고객님 자신의 개인정보를 보호하고 타인의 정보를 침해하지 않을 의무도 가지고 있습니다.
                고객님의 개인정보가 유출되지 않도록 조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오.
                만약 이 같은 책임을 다하지 못하고 타인의 정보를 훼손할 시에는 정보통신망법 등에 의해 처벌받을 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                4) 고객님의 스마트폰이 불법 프로그램, 해킹으로인해 발생되는 책임은 고객님께 있습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                12. 개인정보 자동수집장치의 설치, 운영 및 그 거부에 대한 사항
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) MDN이란 USIM 내에 있는 사용자의 휴대폰 번호 정보를 말합니다. MDN은 이 서비스의 이용자가 앱 실행 시 자동으로 수집이 됩니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 회사가 이 서비스를 제공하는데 수집하는 정보는 이용자의 USIM 일련번호, MDN, 접속로그에 한하며, 그 외의 다른 정보는 수집하지 않습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                13. 개인정보취급방침의 고지 또는 통지방법
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회사가 고객님이 동의한 범위를 넘어 고객님의 개인정보를 이용하거나 제3자에게 제공하기 위해 고객님의 추가적인 동의를 얻고자 하는 때에는
                미리 고객님께 개별적으로 서면, E-mail, 전화, 애플리케이션 내 문의게시판 등에 개재하는 방법 등으로 해당사항을 통지하고 이에 대한 동의를 얻습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 타인에게 고객님의 개인정보의 수집, 보관, 처리, 이용, 제공, 관리, 파기 등을 위탁하는 경우에는 애플리케이션 내의 개인정보취급방침을 통하여 공지사항에 공개합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                3) 회사가 영업의 전부 또는 일부를 양도하거나 합병, 상속 등으로 그 권리, 의무를 이전하는 경우
                서면, E-mail 등을 통하여 고객님께 개별적으로 통지합니다.
                다만, 서면, E-mail 기타의 방법에 의한 통지는 과실 없이 고객님의 연락처를 알지 못하는 경우에는
                애플리케이션 내 공지사항에 30일 이전에 게시하고, 천재, 지변 그 밖에 정당한 사유로 위 홈페이지
                게시가 곤란한 경우에는 2곳 이상의 일반일간신문(고객님의 대부분이 특정 지역에 거주하는 경우에는
                그 지역을 보급구역으로 하는 일반일간신문으로 할 수 있습니다)에 1회 이상 공고하는 것으로 갈음합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                14. 개인정보보호를 위한 기술 및 관리적 대책
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                본 서비스에서는 고객님의 개인정보를 보호하기 위해 기술적 대책과 관리적 대책을 마련하고 있으며, 이를 적용하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 기술적 대책
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                회사는 고객님의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 고객님의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를 암호화하거나 파일 잠금 기능(Lock)을 사용하여 중요한 데이터는 별도의 보안기능을 통해 보호되고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                나. 회사는 백신프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다.
                백신프로그램은 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                다. 회사는 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치(SSL 또는 SET)를 채택하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                라. 회사는 해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및 취약점 분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 관리적 대책
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 회사는 고객님의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있습니다. 그 최소한의 인원에 해당하는 자는 다음과 같습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 개인정보관리책임자 및 담당자 등 개인정보관리업무를 수행하는 자
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 기타 업무상 개인정보의 취급이 불가피한 자
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                나. 회사는 고객님의 개인정보에 대한 접근 및 관리에 필요한 절차 등을 마련하여 소속 직원으로 하여금
                이를 숙지하고 준수하도록 하고 있으며, 개인정보를 취급하는 직원을 대상으로 새로운 보안
                기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육 및 외부 위탁교육을 실시하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                다. 개인정보 관련 취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을 명확히 하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                라. 회사는 컴퓨터를 이용하여 고객님의 개인정보를 처리하는 경우 개인정보에 대한 접근권한을 가진 담당자를 지정하여 ID 및 PASSWORD를 부여하고, 해당 PASSWORD를 정기적으로 갱신하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                마. 회사는 신규직원 채용 시 정보보호서약서 또는 개인정보보호서약서에 서명함으로 직원에 의한 정보유출을 사전에 방지하고
                개인정보취급방침에 대한 이행사항 및 직원의 준수여부를 감사하기 위한 내부절차를 마련하여 지속적으로 시행하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                바. 회사는 직원 퇴직 시 비밀유지서약서에 서명함으로 회원의 개인정보를 취급하였던 자가 직무상 알게 된 개인정보를 훼손/침해 또는 누설하지 않도록 하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                사. 회사는 고객님 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다.
                회원의 경우 개개인이 본인의 개인정보를 보호하기 위해서 자신의 개인정보를 적절하게 관리하고 여기에 대한 책임을 져야 합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                아. 그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실, 유출, 변조, 훼손이 유발될 경우 회사는 지체없이 고객님께 사실을 알리고 적절한 대책과 보상을 강구할 것입니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                15. 개인정보에 관한 민원서비스
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회사는 고객님과의 원활한 의사소통을 위해 고객센터 등 고객상담창구를 운영하고 있으며 고객님께서 문의사항이 있으실 경우 아래의 연락처로 문의하시면 언제든 성실한 답변을 받으실 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 사이버상담: '화재알리미' 애플리케이션 내 Q&A 코너상담에서 사이버 상담원에게 질문을 하실 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 회사는 회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 개인정보관리 책임자 : (주)파이어룩스 대표이사
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 개인정보관리 담당자 :김수연
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 소속부서 : 관리팀
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 전화번호 : 031-478-8193
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - E-mail : firelooks@firelooks.com
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                3) 기타 개인정보 침해에 관한 상담이 필요한 경우에는 한국정보보호진흥원 개인정보침해신고센터, 경찰청 사이버테러대응센터 등으로 문의하실 수 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                가. 개인정보침해신고센터
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 전화: 118
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - URL: <a href="https://privacy.kisa.or.kr">https://privacy.kisa.or.kr</a>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                나. 대검찰청 사이버범죄수사단
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 전화: 02 - 3480 - 3571
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - E-mail: cybercid@spo.go.kr
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                다. 경찰청 사이버테러대응센터
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - 전화: 1566 - 0112
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - URL: <a href="https://www.cyber.go.kr">https://www.cyber.go.kr/</a>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                16. 아동의 개인정보보호
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                만 14세 미만 아동은 서비스를 이용할 수 없습니다.
                만약 회사가 "서비스" 이용과 관련하여 만 14세 미만 아동(이하 "아동"이라 함)의 개인정보를 수집/이용/제공하는 경우,
                해당 아동의 개인정보로 인하여 아동 및 그의 법정대리인이 불이익을 입지 않도록 보호 조치를 취하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                회사는 "서비스" 관련, 아동의 개인정보에 대하여 아래의 행위를 하는 경우에는 해당 아동의 법정대리인의 동의를 얻도록 하고 있습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                - 아동의 "서비스" 가입을 위해 개인정보 수집하거나 "서비스" 가입 시 고지한 범위 또는 서비스이용약관에 명시한 범위를 넘어 이동의 개인정보를 이용하거나 제3자에게 제공하고자 하는 경우
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[3] v-bind:style="sbsa[2]">
                - 아동의 개인정보를 제공받은 자가 개인정보를 제공받은 목적 외의 용도로 이용하거나 제3자에게 제공하는 경우
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                이 경우 회사는 법정대리인의 동의를 얻기 위하여 법정대리인의 성명, 연락처 등 필요한 최소한의 정보를 요구할 수 있습니다.
                이 경우 개인정보의 수집 · 이용 또는 제공 목적 및 법정대리인의 동의가 필요하다는 취지를 아동이 쉽게 이해할 수 있는 평이한 표현으로 아동에게 고지합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                법정대리인의 동의를 얻기 위하여 수집한 법정대리인의 개인정보를 해당 법정대리인의 동의 여부를 확인하는 목적 외의 용도로 이를 이용하거나 제 3 자에게 제공하지 않습니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[1] v-bind:style="sbsa[1]">
                17. 광고성 정보 전송
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                1) 회사는 고객의 사전 동의 없이 영리목적의 광고성 정보를 전송하지 않습니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                2) 회사는 신상품이나 이벤트 정보안내 등 고객 지향적인 마케팅을 수행하기 위하여 광고성 정보를 E-mail으로 전송하는 경우에는
                광고성 정보 전송에 대한 고객의 사전 동의를 득하고 E-mail의 제목란 및 본문란에 아래와 같이 고객이 광고성 정보임을 쉽게 알아볼 수 있도록 조치합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[4] v-bind:style="sbsa[2]">
                - E-mail의 제목란 : '(광고)'라는 문구를 제목란의 처음에 빈칸 없이 한글로 표시하고 이어서 E-mail 본문란의 주요 내용을 표시합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                3) 광고수신에 동의한 고객에게 팩스ㆍ이동전화 문자메시지 전송 등 E-mail 이외의 방법을 통해
                영리목적의 광고성 정보를 전송하는 경우에도 전송자의 명칭을 표기하는 등 필요한 조치를 취합니다.
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="11" :class=cbsa[2] v-bind:style="sbsa[2]">
                4) 서비스에서는 고객의 광고성 정보 수신동의시, 수신거부시, 수신동의 철회 시 해당 사실을 고객에게 해당 사실 발생일로부터 14일내에 고지합니다.
                또한 고객이 광고성 정보 수신동의를 한 날로부터 매 2년 마다 고객의 광고성 정보 수신동의 사실을 고객에게 확인합니다.
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" :class=cbsa[5] v-bind:style="sbsa[3]">
                (주)파이어룩스 | 대표이사 : 임정아 | 주소 : 충청북도 청주시 서원구 남이면 양촌4길 23-1
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" :class=cbsa[6] v-bind:style="sbsa[3]">
                <!-- 사업자등록번호 : 753-81-02469 | 이메일 : firelooks@firelooks.com | 고객센터 : 1588- -->
                사업자등록번호 : 753-81-02469 | 이메일 : firelooks@firelooks.com | 고객센터 : 031-478-8193
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
import {
    onMounted,
    onUpdated
} from "vue";
import {
    faLog,
    classBindsServiceAgreement,
    styleBindsServiceAgreement,
} from "../common/faCommon.js";

const cbsa = classBindsServiceAgreement;
const sbsa = styleBindsServiceAgreement;

onUpdated(() => {
    faLog(0, "[PrivatePolicy] [onUpdated]");
});

onMounted(() => {
    faLog(0, "[PrivatePolicy] [onMounted]");
});

</script>